import { z } from 'zod'

/**
 * Политика паролей, ТЗ 4.1.3: минимум 12 символов, заглавная и строчная буква, цифра
 * и специальный символ (любой, кроме букв, цифр и пробелов).
 * Зеркало backend `password_meets_policy` (app/core/security.py), менять только вместе;
 * длину и тексты ошибок сверяет backend/tests/unit/test_password_policy.py.
 */
export const PASSWORD_MIN_LENGTH = 12

export const PASSWORD_HINT =
  'Минимум 12 символов, заглавная и строчная буква, цифра и специальный символ. Пароли из списков утёкших не принимаются'

/** Текст первой невыполненной проверки или null, если пароль подходит. */
export function passwordPolicyError(password: string): string | null {
  // [...password] считает символы так же, как len() на бэкенде (а не UTF-16 единицы)
  if ([...password].length < PASSWORD_MIN_LENGTH) return 'Минимум 12 символов'
  if (!/\p{Lu}/u.test(password)) return 'Должна быть хотя бы одна заглавная буква'
  if (!/\p{Ll}/u.test(password)) return 'Должна быть хотя бы одна строчная буква'
  if (!/\p{Nd}/u.test(password)) return 'Должна быть хотя бы одна цифра'
  if (!/[^\p{L}\p{N}\s]/u.test(password)) return 'Должен быть хотя бы один специальный символ'
  return null
}

export const passwordSchema = z.string().superRefine((value, ctx) => {
  const error = passwordPolicyError(value)
  if (error) ctx.addIssue({ code: 'custom', message: error })
})
